import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
export default function VideoPanel(props) {
  const [isPlaying, setIsPlaying] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPlaying(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div style={{ width: "100%", height: "97vh" }}>
      <ReactPlayer
        src="https://www.youtube.com/watch?v=4DkfqOvN2M4"
        width={"100%"}
        height={"100%"}
        controls
        volume
        loop
        muted
        playing={isPlaying}
      />
    </div>
  );
}
